import { IOmniaShell, isNumber, labels, manureStockAnalysisFields as analysisFields, manureStockTotalFields as totalFields, filterAvailableTypes, IManureStock, IManureType, StockType } from "../../omnia"
import { TypedStockEditCtrl } from "../editTypedStock"

export class ManureStockEditCtrl extends TypedStockEditCtrl {

    static create(): ng.IDirective {

        return TypedStockEditCtrl.create(ManureStockEditCtrl, "app/stocks/edit/manure/editManure.html");

    };

    private manureStock: IManureStock = <any>{};
    public manureTypes: IManureType[];
    public allowedManureTypes: IManureType[];

    static $inject = ["$scope", "OmniaShell"]

    constructor($scope: ng.IScope, shell: IOmniaShell) {
        super($scope, shell)
    }

    protected setup() {

        this.manureStock = <IManureStock>this.stock;

        this.manureTypes = this.stocks.getManureTypes();

        this.allowedManureTypes = filterAvailableTypes(this.manureTypes, this.stocks.holding.Region);

        if (this.isAnalysisEmpty()) {
            this.updateAnalysisFromType(this.manureType);
        }

    }

    protected getStockType(): StockType {
        return StockType.Manure;
    }

    get manureType(): IManureType {
        return this.manureStock.ManureType;
    }

    set manureType(value: IManureType) {

        var changed = (this.manureStock.ManureType != value);
        var resetAnalysis: boolean;

        if (changed && value) {
            resetAnalysis = this.isAnalysisEmpty() || this.isAnalysisUnchanged(this.manureType);
        }

        this.manureStock.ManureType = value;
        this.manureStock.ManureTypeId = (value ? value.ManureTypeId : null);

        if (resetAnalysis) {
            this.updateAnalysisFromType(value);
            this.manureStock.Custom = false;
        }

    }

    get units(): string {
        if (this.manureType) {
            return labels.ManureUnit(this.manureType.Unit)
        }
    }

    get costUnits(): string {
        if (this.manureType) {
            return this.manureType.Liquid ? "m³" : "T";
        }
    }

    isCustom(): boolean {
        return this.manureStock && this.manureStock.Custom;
    }

    get customSelector(): any {
        return (this.manureStock.Custom ? "1" : "0");
    }

    set customSelector(value: any) {

        var custom = !!parseInt(value);

        if (custom != this.manureStock.Custom) {
            this.updateAnalysisFromType(this.manureType);
            this.manureStock.Custom = !!parseInt(value);
        }
    }

    canChangeType() {
        return (this.newStock);
    }

    canChangeCustom() {
        return !this.isUsedInPlans()
    }

    canChangeStock(): boolean {
        return !this.isUsedInPlans()
    }

    canChangeAnalysis(): boolean {
        return (!this.isUsedInPlans()) && this.manureStock && this.manureStock.Custom;
    }

    canChangeNMax(): boolean {
        return (!this.isUsedInPlans()) && (!!this.manureStock);
    }

    private supportsUricAcid(): boolean {
        return this.manureType && isNumber(this.manureType.NUricAcid);
    }

    private isAnalysisEmpty() {
        return analysisFields.every(f => !isNumber(this.stock[f]));
    }

    private isAnalysisUnchanged(type: IManureType) {

        if (type) {
            return analysisFields.every(f => type[f] == this.stock[f]);
        }

        return true;

    }

    private updateAnalysisFromType(type: IManureType) {

        if (type) {
            analysisFields.forEach(f => {
                this.stock[f] = type[f];
            });
        }
    }

    private hasNoNutrientRates(): boolean {
        return totalFields.map(f => this.stock[f] || 0).every(t => !t);
    }

    private hasInvalidNutrientRates(): boolean {
        return totalFields.map(f => this.form[f]).some(f => f && f.$invalid);
    }

    private checkNitrogenAnalysis(): boolean {
        var a = (this.stock["NAmmonium"] || 0) + (this.stock["NNitrate"] || 0) + (this.stock["NUricAcid"] || 0);
        var n = this.stock["N"] || 0;
        return (n >= a);
    }

    canCommit(): boolean {

        if (super.canCommit()) {

            if (!this.manureType) return false;

            if (this.isCustom()) {
                if (this.hasNoNutrientRates()) return false;
                if (this.hasInvalidNutrientRates()) return false;
                if (!this.checkNitrogenAnalysis()) return false;
            }

            return true;

        }

    }

    commit(): ng.IPromise<any> {

        if (!this.canCommit()) {
            return;
        }

        let model = this.prepareCommitModel(this.manureStock);

        return this.stocks.editManureStock(model);

    }

}
